import {Brick} from "./BrickMailType";
import {createContext, FC, useContext, useState} from "react";
import * as React from "react";

interface ClipboardContextType {
   clipboardBrick: Brick | null;
   setClipboardBrick: (brick: Brick | null) => void;
}

const ClipboardContext = createContext<ClipboardContextType>({
   clipboardBrick: null,
   setClipboardBrick: () => {},
});

export const ClipboardProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
   const [clipboardBrick, setClipboardBrick] = useState<Brick | null>(null);

   return (
      <ClipboardContext.Provider value={{ clipboardBrick, setClipboardBrick }}>
         {children}
      </ClipboardContext.Provider>
   );
};

// Create a hook to use the clipboard
export const useClipboard = () => useContext(ClipboardContext);
